import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class PndService {
  GetPndByTaxPeriodModelList(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndByTaxPeriodModelList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetWhtCertificateTableByPeriodTax(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        fromDate: data.fromDate,
        toDate: data.toDate,
        pndType: data.pndType,
        orderText: data.orderText,
      },
    };
    return service.peakTaxAPI
      .post("/api/Pnd/GetWhtCertificateTableByPeriodTax", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  UpdateIsFiledPnd(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/UpdateIsFiledPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPndTextFile(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndTextFile", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateIsClosingEntryPnd(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/UpdateIsClosingEntryPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetIsFiledPndModel(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetFiledPndModelFromMongo", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetWhtCertificateTableByPndId(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetWhtCertificateTableByPndId", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPndTable(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPndTableAdvanceSearch(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndTableAdvanceSearch", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPndFormPeriodYear(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        merchantId: MerchantId(),
        year: data.year,
        pndType: data.pndType,
        isDeleted: data.isDeleted,
      },
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndPeriodYear", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  InsertPnd(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/InsertPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetPndByIdModel(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetPndByIdModel", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdatePnd(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/UpdatePnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateStatusPnd(data: any) {
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI.post("/api/Pnd/UpdateStatusPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidPnd(pndByIdOption: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pndByIdOption,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetFileStoragePnd(pndId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: pndId,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetFileStoragePnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetFileMarkReceiptPnd(pnd: any) {
    const _input = {
      merchantId: MerchantId(),
      data: { pndId: pnd.pndId, pndType: pnd.pndType },
    };
    return service.peakTaxAPI.post("/api/Pnd/GetFileMarkReceiptPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  AddFileStoragePnd(insertFilesStorage: any) {
    const requestBody: any = [];
    insertFilesStorage.forEach((file: any) => {
      requestBody.push({ merchantId: MerchantId(), data: file });
    });
    return Promise.all(
      requestBody.map((request: any) =>
        service.peakTaxAPI.post("/api/Pnd/AddFileStoragePnd", request, SetHeaderService()).then((res) => {
          return res;
        })
      )
    );
  }
  VoidFileMarkReceiptPnd(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };

    return service.peakTaxAPI.post("/api/Pnd/VoidFileMarkReceiptPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  AddFileMarkReceiptPnd(insertFilesStorage: any) {
    const requestBody: any = [];
    insertFilesStorage.forEach((file: any) => {
      requestBody.push({ merchantId: MerchantId(), data: file });
    });
    return Promise.all(
      requestBody.map((request: any) =>
        service.peakTaxAPI.post("/api/Pnd/AddFileMarkReceiptPnd", request, SetHeaderService()).then((res) => {
          return res;
        })
      )
    );
  }
  VoidFileStoragePnd(voidFileStorage: any) {
    const _input = {
      merchantId: MerchantId(),
      data: voidFileStorage,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidFileStoragePnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateIsPaidPnd(pndUpdateIsPaidOption: any) {
    const _input = {
      merchantId: MerchantId(),
      data: pndUpdateIsPaidOption,
    };
    return service.peakTaxAPI.post("/api/Pnd/UpdateIsPaidPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  CreateExpenseByIsClosingEntryPnd(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        payment: input.payment,
        language: i18n.locale,
        pndId: input.pndId,
        pndType: input.pndType,
        isClosingEntry: true,
      },
    };
    return service.peakTaxAPI
      .post("/api/Pnd/CreateExpenseByIsClosingEntryPnd", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  CreateExpenseByIsClosingEntryPndTimeline(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        payment: input.payment,
        language: i18n.locale,
        pndId: input.pndId,
        pndType: input.pndType,
        isClosingEntry: true,
      },
    };
    return service.peakTaxAPI
      .post("/api/Pnd/CreateExpenseByIsClosingEntryPndTimeline", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetClosingEntryPndModelFromMongo(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        journalDate: new Date(),
        language: i18n.locale,
        pndId: input.pndId,
        pndType: input.pndType,
        isClosingEntry: false,
      },
    };
    return service.peakTaxAPI
      .post("/api/Pnd/GetClosingEntryPndModelFromMongo", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetCommentLogPnd(pndId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: pndId,
    };
    return service.peakTaxAPI.post("/api/Pnd/GetCommentLogPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  AddCommentLogPnd(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Pnd/AddCommentLogPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidCommentLogPnd(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidCommentLogPnd", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidIsClosingEntryPndExpense(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidIsClosingEntryPndExpense", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidPndExpenseTimeline(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidPndExpenseTimeline", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  VoidIsClosingEntryPndJournal(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI.post("/api/Pnd/VoidIsClosingEntryPndJournal", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetCheckingWhtData(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetCheckingWhtCertificateData", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  UpdateCheckingWhtCertificateData(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/UpdateCheckingWhtCertificateData", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetWhtCertificateDetailBySourceId(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetWhtCertificateDetailBySourceId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new PndService();
